import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49419142&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=49419142&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=49419142&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49419142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49419142')) {
      api.createRecord('49419142', component.options)
    } else {
      api.reload('49419142', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=49419142&scoped=true", function () {
      api.rerender('49419142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mediaManage/recommendStrategy/index.vue"
export default component.exports